import { Component, Input } from '@angular/core';
import { take, takeUntil } from 'rxjs/operators';
import { LoginStatusService } from 'src/app/services/auth/login/login-status.service';
import { LoggedStatus } from 'src/app/services/auth/login/login.models';
import { TournamentDetailsService } from 'src/app/services/tournaments/tournament-details.service';
import { Tournament, TournamentRankEntry, TOURNAMENTTYPE } from 'src/app/services/tournaments/tournaments.models';
import { LicenceService } from 'src/app/services/utils/licence.service';
import { environment } from 'src/environments/environment';
import { BasePageComponent } from '../../base-page/base-page.component';

@Component({
  selector: 'app-tournament-overview',
  templateUrl: './tournament-overview.component.html',
  styleUrls: ['./tournament-overview.component.scss']
})
export class TournamentOverviewComponent extends BasePageComponent {

  constructor(
    protected tournamentDetailsService: TournamentDetailsService,
    protected loginStatusService: LoginStatusService,
    protected licenceService: LicenceService
  ) { super() }

  @Input() ref: string;
  @Input() tournament: Tournament;

  rank: TournamentRankEntry[];
  myPosition: number;
  currency: string;
  minBetCurrency: string;
  minBet: number;
  nickname: string;
  isLogged: boolean;
  isShowMore: boolean = false;
  INITIAL_RANK_LENGTH: number = 20;
  SHOWMORE_RANK_LENGTH: number = 200;
  rankSize = this.INITIAL_RANK_LENGTH;


  getDetails() {
    this.loginStatusService.getLoginStatus().pipe(takeUntil(this.unsubscribe)).subscribe(status => {
      if (status.isLogged === LoggedStatus.logged) {
        this.isLogged = true;
        this.currency = status.currency;
        const minBetCurrencies = this.tournament.minBetCurrencies;
        if (minBetCurrencies && minBetCurrencies[this.currency.toLowerCase()]) {
          this.minBet = minBetCurrencies[this.currency.toLowerCase()];
          this.minBetCurrency = status.currency;
        }
        else {
          this.minBet = this.tournament.minBet;
          this.minBetCurrency = environment.baseCurrency;
        }
      }
      else {
        this.isLogged = false;
        this.minBet = this.tournament.minBet;
        this.minBetCurrency = environment.baseCurrency;
      }
    })
    // this.tournamentDetailsService.getTournamentPrizes(this.ref).pipe(take(1)).subscribe(prizes => {
    //   this.numberPrizes = prizes?.length;
    // })
    if (this.tournament.tournamentType !== TOURNAMENTTYPE.UPCOMMING) {
      this.tournamentDetailsService.getTournamentRank(this.ref).subscribe(resp => {
        this.rank = resp.rank;
        this.myPosition = resp.myPosition
      })
    }
  }
  ngOnInit(): void {
    this.getDetails()
  }

  myPoints: number;
  numberPrizes: number = 25;

}
